<template> 
  <div>
    <van-popup :style="{width: '314px', minHeight: '285px', borderRadius:'6px' }" v-model="isPageShow" :close-on-click-overlay=false>
      <div class="shut_down" @click="shutDown">关闭</div>
      <div class="prompt"> 
        <p>为提高您的贷款成功率，请您先进行身份认证</p>
        <div class="content">
          <router-link :to="{path: '/enterpriseDetail',query: {}}" :class="['content-item1',chooseStatus?'content-item2':'']" replace @click="chooseCertification">企业认证</router-link>
          <div :class="['content-item1',chooseStatus?'':'content-item2']" @click="goPersonl">个人认证</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'certificationOptions',
  data () {
    return {
      isPageShow:false,
      chooseStatus:true
    }
  },
  watch: {
    isPageShow(val) {
      localStorage.setItem('companyBack',window.location.href);
      if(val) {
        localStorage.setItem('certificationInfo','3')
      }
    }
  },

  methods:{
    // 关闭弹窗
    shutDown() {
      localStorage.removeItem('certificationInfo')
      this.isPageShow = false
    },

    // 点击个人
    goPersonl() {
      this.chooseStatus = false
      this.$common.infoSubmit('/app/info/find',{type:"personal",dkId: localStorage.getItem("dkId")},(res) => {
				// console.log(res)
        if(!res) {
          this.$router.replace({path: '/identity',query: {type:'person'}})
        } else {
          // this.$router.replace({path: '/personlUnbundling'})
          localStorage.setItem("livingToPage", window.location.href);
          let _this = this
          let sendData = {
						authType: 'person',
						dkId: localStorage.getItem("dkId"),
						//正式环境
						notifyUrl: process.env.NODE_NOTIFY_URL, //faceId回调后台地址
						returnUrl: process.env.NODE_RETURN_URL, //识别后前端回调地址
						//测试环境
						//  notifyUrl: "http://suputech.imwork.net/app/api/living/notify",//faceId回调后台地址
						//  returnUrl: "http://suputech.imwork.net/living"//识别后前端回调地址
					};
						_this.$toast.loading({
						message: '正在加载...',
						forbidClick: true,
						duration:0
						});
						_this.$common.infoSubmit(
						"/app/auth/getH5FaceId",
						sendData,
						(res) => {
						console.log("getToken成功 ", res);
						_this.$common.pageEventHandle({ eventType: 9 });
            localStorage.setItem("sendDataTx", JSON.stringify(sendData));
						location.replace(
							`https://ida.webank.com/api/web/login?from=${res.from}&h5faceId=${res.h5faceId}&nonce=${res.nonce}&orderNo=${res.orderNo}&redirectType=${res.redirectType}
							&resultType=${res.resultType}&sign=${res.sign}&url=${res.url}&userId=${res.userId}&version=${res.version}&webankAppId=${res.webankAppId}
							`
						);
						},
						(res) => {
						// console.log("----------------")
						_this.$toast.loading({
						message: '正在加载...',
						forbidClick: false,
						});
						_this.isRequest = false
						console.log("getToken失败 ", res);
						_this.isClick = true;
						if (res == "NO_FACE_FOUND") {
							_this.$toast.fail("请保持图片面部清晰");
						} else if (res == "MULTIPLE_FACES") {
							_this.$toast.fail("检测到了多张人脸");
						} else {
							_this.$toast.fail("请重新上传图片");
						}
						// _this.$common.errTip("识别失败");
						},
						60000
						);
        }
			})
    },

    // 点击企业
    chooseCertification() {
      this.chooseStatus = true
    }
  }
}
</script>

<style lang="less" scoped>
.certification-type{width: 84%; padding: 52px 10px 38px 10px; margin: 0 auto; background-color: #fff;border-radius: 5px;}
.tip-str{font-size: 15px; line-height: 21px; color: #303030;text-align: center;display: block; padding: 0px 10px;}
.select-type-box{width: 100%; margin: 0px auto; margin-top: 90px;}
.tab{display: block;width: 49%;height: 43px; float: left;line-height: 43px;text-align: center;  border-radius: 22px;margin-right: 2%;background-color: #E4E4E4;color: #303030;font-weight: 600;}
.tab:last-child{margin-right: 0%; background-color: #E4E4E4;color: #303030;}
  .tab:active{ background-color: #3377ff;color: #fff;}
  .shut_down {
    text-align: right;
    padding-top: 10px;
    padding-right: 10px;
    font-size: 15px;
    color: #303030;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .prompt {
    width: 100%;
    padding: 30px;
    color: #303030;
    font-size: 15px;
    font-weight: 400;
     p {
        color: #3B3B3B;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        line-height: 26px;
      }
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100px;
      margin-top: 25px;
      margin-bottom: 12px;
      .content-item1 {
        font-family: PingFangSC-Regular, PingFang SC;
        text-align: center;
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        font-weight: 400;
        width: 100%;
        border: none;
        border-radius: 23px;
        background-color: #F0F5FF;
        color: #2660CEFF;
        margin-top: 21px;
        border: 1px solid #2660CE;
      }
      .content-item2 {
        background-color: #2660CEFF;
        color: #fff;
      }
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/modules/popup/certificationOptions.vue